import { formatPrismicData } from '@monofront/business/utils';
import { BubblesInTabsProps, IBubblesInTabs } from './types';

export const mapBubblesInTabs = ({
  prismicContent,
}: {
  prismicContent: BubblesInTabsProps;
}): IBubblesInTabs => {
  const { primary, items }: IBubblesInTabs = formatPrismicData(prismicContent);

  return {
    primary,
    items,
  };
};
